import { createSelector } from 'reselect';

export function getProvider(state) {
  return state.provider;
}

//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentProvider = createSelector(
  getProvider,
  provider => provider.get(provider.get('user'))
);
